import axios from 'axios';
import React, { useContext, useState } from "react";
import { makeStyles,useTheme } from "@material-ui/core/styles";

import {
  Button,
  Box,
	CircularProgress,
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";

import PublishIcon from "@material-ui/icons/Publish";


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
    display:"inline-block"
  },
	buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})); 

export default function PushCreditFileButton({caption,channel_shortname,credit_id, file_key, disabled, channel_display_name}) {
	const theme = useTheme();
	const classes = useStyles();
	
  const [isLoading, setIsLoading] = useState(false);


	const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);
  

  const pushCreditFile = () => {
    setIsLoading(true);
    pageContext.addRunningJob(
      channel_shortname + "_files_" + file_key + "_" + credit_id,
      "Datei Upload zur " + channel_display_name,
      "Finanzierung Nr." + credit_id,
      Date.now(),
      <PublishIcon />
    );
    const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/channels/pushcreditfile/${credit_id}/${channel_shortname}/${file_key}`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
		};
    axios(options)
      .then((res) => {
        setIsLoading(false);
				console.log(res);
        if (res.data.success) {
          if (res.data.message)
            pageContext.setInfoDialog({
              open: true,
              title: 'Dateiübertragung zur ' + channel_display_name,
              message: <Box sx={{whiteSpace: "pre-line"}}>
                  {res.data.message}
                </Box>,
              handleOK: () => {
                pageContext.setInfoDialog({
                  open: false,
                });
              },
              captionOK: "Ok, verstanden",
            });
          else
            pageContext.setInfoMessage("Die Daten wurden an die Bank übertragen.")
        } else {
					if (res.data.message)
						pageContext.setErrorMessage(res.data.message);
					else
						pageContext.setErrorMessage("Bei der Datenübertragung ist ein Fehler aufgetreten.");
        }
        pageContext.removeRunningJob(channel_shortname + "_files_" + file_key + "_" + credit_id);
      })
      .catch((err) => {
        setIsLoading(false);
				console.log(err);
        pageContext.setErrorMessage("Die Verbindung konnte nicht hergestellt werden!");
        pageContext.removeRunningJob(channel_shortname + "_files_" + file_key + "_" + credit_id);
			});
  }

  return (
    <div className={classes.wrapper}>
      <Button
        disabled={isLoading || disabled}
        size="small"
        variant="contained"
        startIcon={<PublishIcon />}
        onClick={() => {
          pushCreditFile();
        }}>
        {caption}
      </Button>
		  {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </div>
	);
}
